import React, { Component } from "react";
import PropTypes from "prop-types";
import SendMessageConfirmModal from "../send_message_confirm_modal";

class SendMessageButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isModalShow: false
    };
  }

  handleModalShow = () => {
    this.setState(prevState => (
      { isModalShow: !prevState.isModalShow }
    ));
  };

  render () {
    const { isModalShow } = this.state;
    const { name, contactable } = this.props;

    return contactable === true && (
      <td id='cover-btn' className='d-none d-lg-table-cell'>
        <button type='button' className='btn btn-outline-light btn-m' data-ga-label='btn-message-head' onClick={this.handleModalShow}>
          メッセージを送る
        </button>

        <SendMessageConfirmModal
          name={name}
          isModalShow={isModalShow}
          handleModalShow={this.handleModalShow}
        />
      </td>
    );
  }
}

SendMessageButton.propTypes = {
  name: PropTypes.string.isRequired,
  contactable: PropTypes.bool.isRequired
};

export default SendMessageButton;
